import React from 'react';
import Thumbs from '../Thumbs';
import KeyboardShortcuts from '../KeyboardShortcuts/KeyboardShortcuts';

const LeftPanel = (props) => {
  return (
    <div style={{ 
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }}>
      <div style={{ flex: '1 1 auto', minHeight: 0 }}>
        <Thumbs {...props} />
      </div>
      <div style={{ flex: '0 0 auto', paddingTop: 20, marginTop: '10px' }}>
        {props.is_labLoaded && (
          <KeyboardShortcuts
            current_locale={props.current_locale}
            formattedTime={props.formattedTime}
            thresholdReached={props.thresholdReached}

          />
        )}
      </div>
    </div>
  );
};

export default LeftPanel;
